/* Bulk landing — "The Pricing Board" interactivity.
   Real pricing: perUnit = (garment + front-print) x (1 - bulk discount). Bands match config.bulkDiscounts. */
(function () {
  var root = document.getElementById('bulk-landing');
  if (!root) return;

  var garment = (parseInt(root.dataset.featPrice, 10) || 2800) / 100;   // dollars inc GST
  var print = (parseInt(root.dataset.printPrice, 10) || 1195) / 100;
  var base = garment + print;                                            // per-unit, no discount
  var cfgUrl = root.dataset.configureUrl || '/collections/as-colour';
  var DETENTS = [10, 20, 50, 100, 200, 400];                               // real bulk breakpoints
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function discountFor(qty) {
    if (qty >= 400) return 40; if (qty >= 200) return 30; if (qty >= 100) return 20; if (qty >= 50) return 15;
    if (qty >= 20) return 10; if (qty >= 10) return 5; return 0;
  }
  function money(n) { return '$' + n.toFixed(2); }
  function moneyBig(n) { return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function perUnit(qty) { return base * (1 - discountFor(qty) / 100); }

  /* ---- split-flap price ---- */
  var flapsEl = root.querySelector('[data-board-price]');
  var flapChars = [];
  function renderFlaps(str) {
    if (flapChars.length !== str.length) {
      flapsEl.innerHTML = '';
      flapChars = str.split('').map(function (ch) {
        var el = document.createElement('span');
        el.className = 'bl-flap' + (/[0-9]/.test(ch) ? '' : ' bl-thin');
        el.textContent = ch;
        flapsEl.appendChild(el);
        return { el: el, ch: ch };
      });
      return;
    }
    str.split('').forEach(function (ch, i) {
      var f = flapChars[i];
      if (f.ch === ch) return;
      f.ch = ch;
      if (reduce) { f.el.textContent = ch; return; }
      f.el.classList.remove('is-flip');
      void f.el.offsetWidth;
      f.el.classList.add('is-flip');
      setTimeout(function () { f.el.textContent = ch; }, 80 + i * 20);
    });
  }

  /* ---- board update ---- */
  var saveEl = root.querySelector('[data-board-save]');
  var markerEl = root.querySelector('[data-board-marker]');
  var rungs = root.querySelectorAll('[data-board-ladder] .bl-rung');
  var detentEls = [];
  var lrows = root.querySelectorAll('[data-tier-grid] [data-lrow]');
  var range = root.querySelector('[data-board-range]');
  var sideEl = root.querySelector('[data-board-side]');   // discounted price of an additional print side

  function update(idx) {
    var qty = DETENTS[idx];
    var disc = discountFor(qty);
    var pu = perUnit(qty);
    // Board's currently-selected quantity, read by the CTA click handler
    // (bulk-landing.liquid) so a visitor who dragged to e.g. 200 units and
    // clicks "Start your order" carries that qty into the Kit Room modal
    // instead of downgrading to the modal's 100-unit default.
    root.dataset.boardQty = String(qty);
    renderFlaps(money(pu));
    saveEl.textContent = qty + ' units = ' + moneyBig(pu * qty) + ' · you save ' + moneyBig((base - pu) * qty) + ' (' + disc + '% off)';
    if (sideEl) sideEl.textContent = money(print * (1 - disc / 100));
    if (range) range.setAttribute('aria-valuetext', qty + ' units');
    // marker tracks the thumb: thumb sits at idx/(n-1)
    markerEl.style.left = ((DETENTS.length > 1 ? idx / (DETENTS.length - 1) : 0) * 100) + '%';
    rungs.forEach(function (r, i) { r.classList.toggle('is-active', i <= idx); });
    detentEls.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    // only the FIRST row matching this discount lights (guards against duplicate bands)
    var lit = false;
    lrows.forEach(function (row) {
      var m = !lit && row.getAttribute('data-lrow') === String(disc);
      if (m) lit = true;
      row.classList.toggle('is-active', m);
    });
  }

  /* ---- detent buttons (keyboard-operable) ---- */
  var detentWrap = root.querySelector('[data-board-detents]');
  if (detentWrap) {
    DETENTS.forEach(function (q, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bl-detent'; b.textContent = q;
      b.setAttribute('aria-label', q + ' units');
      b.addEventListener('click', function () { range.value = i; update(i); range.focus(); });
      detentWrap.appendChild(b); detentEls.push(b);
    });
  }
  if (range) {
    range.addEventListener('input', function () { update(parseInt(range.value, 10)); });
    var iv = parseInt(range.value, 10); update(Number.isNaN(iv) ? DETENTS.length - 1 : iv);
  }

  /* ---- big ladder-grid example prices ---- */
  root.querySelectorAll('[data-tier-ex]').forEach(function (el) {
    var pct = parseInt(el.getAttribute('data-tier-ex'), 10) || 0;
    el.textContent = money(base * (1 - pct / 100));
  });

  /* ---- "Need a quote?" ---- */
  function openQuote(e) {
    if (e) e.preventDefault();
    var idx = range ? parseInt(range.value, 10) : DETENTS.length - 1;
    var ctx = { source: 'bulk-landing', qty: DETENTS[idx], product: (root.dataset.featTitle || '') };
    track('bl_quote_request', ctx);
    if (typeof window.openPrintiblyQuote === 'function') { window.openPrintiblyQuote(ctx); return; }
    window.dispatchEvent(new CustomEvent('printibly:quote-request', { detail: ctx }));
    // interim until the quote modal ships: open Ari chat if present, else the configurator
    var ari = document.querySelector('[data-ari-launcher],#printicom-launcher,.printicom-chat-launcher,.ask-ari-launcher');
    if (ari) { ari.click(); return; }
    window.location.href = cfgUrl;
  }
  root.querySelectorAll('[data-bl-quote]').forEach(function (b) { b.addEventListener('click', openQuote); });

  /* ---- sticky CTA (inert until hero scrolls away) ---- */
  var sticky = root.querySelector('[data-bl-sticky]');
  var hero = root.querySelector('.bl-hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var out = !entries[0].isIntersecting;
      sticky.hidden = !out;                 // removes from tab order when off-screen
      sticky.classList.toggle('is-in', out);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
  }

  /* ---- analytics: CTA clicks, slider interaction, quote requests → dataLayer + gtag ---- */
  function track(evt, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: evt }, params || {}));
      if (typeof window.gtag === 'function') window.gtag('event', evt, params || {});
    } catch (_) {}
  }
  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-bl-cta]');
    if (el) track('bl_cta_click', { cta: el.getAttribute('data-bl-cta') });
  });
  var sliderTracked = false;
  if (range) range.addEventListener('input', function () {
    if (!sliderTracked) { sliderTracked = true; track('bl_slider_interact', { source: 'bulk-board' }); }
  });
})();
